import { Pipe, PipeTransform } from '@angular/core';
import {
  FarBolt,
  FarBoxOpenFull,
  FarBriefcase,
  FarChevronRight,
  FarComments,
  FarEye,
  FarHandshakeSimple,
  FarHouse,
  FarMobile,
  FarPenNib,
  FarPhone,
  FarTv,
  FarTag,
  FarLocationDot,
  FarUser,
  FarHouseChimney,
  FarMagnifyingGlass,
} from '@virginmediao2/momentum-icons/icons/far';
import { Icon } from '@virginmediao2/momentum-icons';
import { FalFaceFrown } from '@virginmediao2/momentum-icons/icons/fal';
import { FasCircleCheck, FasCircleExclamation } from '@virginmediao2/momentum-icons/icons/fas';

@Pipe({ name: 'strapiIcon', standalone: true })
export class IconPipe implements PipeTransform {
  transform(value: any): Icon {
    switch (value) {
      case 'faHome':
        return FarHouse;
      case 'faEye':
        return FarEye;
      case 'faExchange':
        return FarBolt;
      case 'faHandshakeSimple':
        return FarHandshakeSimple;
      case 'faMobile':
        return FarMobile;
      case 'faBriefcase':
        return FarBriefcase;
      case 'faPenNib':
        return FarPenNib;
      case 'faComments':
        return FarComments;
      case 'faTv':
        return FarTv;
      case 'faBolt':
        return FarBolt;
      case 'faBoxFull':
        return FarBoxOpenFull;
      case 'faPhone':
        return FarPhone;
      case 'fas fa-tag':
        return FarTag;
      case 'faLocationDot':
        return FarLocationDot;
      case 'faUser':
        return FarUser;
      case 'faHouseChimney':
        return FarHouseChimney;
      case 'faSearch':
        return FarMagnifyingGlass;
      case 'frown':
        return FalFaceFrown;
      case 'FalFaceFrown':
        return FalFaceFrown;        
      case 'fasCircleExclamation':
        return FasCircleExclamation;
      case 'fasCircleCheck':
      case 'FasCircleCheck':
      case 'check-circle':        
        return FasCircleCheck;
      case 'FasCircleExclamation':
        return FasCircleExclamation;
      default:
        console.error('No such icon', value);
        return FarChevronRight;
    }
  }
}
